import { ARUserStorage } from '@relayter/core';
import { Deserialize, Serialize } from 'cerialize';
import { Observable, Subject } from 'rxjs';
import { UserModel } from '../models/api/user.model';

export class UserStorage extends ARUserStorage {
    private static readonly subject: Subject<UserModel> = new Subject<UserModel>();

    /**
     * Set a user object in the localstorage
     * @param {UserModel} user
     */
    public static setUser(user: UserModel): void {
        const userString = JSON.stringify(Serialize(user));
        localStorage.setItem(this.STORE_KEYS.USER, userString);
        this.subject.next(user);
    }

    /**
     * Get a user object from the localstorage
     */
    public static getUser(): UserModel {
        const user = localStorage.getItem(this.STORE_KEYS.USER);
        const json = JSON.parse(user);
        return Deserialize(json, UserModel);
    }

    /**
     * Clear the user in the localstorage
     */
    public static removeUser(): void {
        localStorage.removeItem(this.STORE_KEYS.USER);
        this.subject.next(null);
    }

    /**
     * Get a user object from the localstorage
     * @returns {Observable<UserModel>}
     */
    public static getSubject(): Observable<UserModel> {
        return this.subject.asObservable();
    }
}
